/* BK Купи повече – спести повече. Избраният вариант задава броя в количката;
   ако вариантът има код за отстъпка, кодът се добавя в количката преди продукта. */
(function () {
  if (customElements.get('bk-qty-breaks')) return;

  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function fallbackMoney(cents, format) {
    cents = Math.round(Number(cents) || 0);
    var f = format || '€{{amount_with_comma_separator}}';
    var m = f.match(/\{\{\s*(\w+)\s*\}\}/);
    var kind = m ? m[1] : 'amount';
    function fmt(n, dec, th, ds) {
      var parts = (n / 100).toFixed(dec).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, th);
      return parts[1] ? parts[0] + ds + parts[1] : parts[0];
    }
    var v;
    switch (kind) {
      case 'amount_no_decimals': v = fmt(cents, 0, ',', '.'); break;
      case 'amount_with_comma_separator': v = fmt(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': v = fmt(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': v = fmt(cents, 2, "'", '.'); break;
      case 'amount_with_space_separator': v = fmt(cents, 2, ' ', ','); break;
      default: v = fmt(cents, 2, ',', '.');
    }
    return m ? f.replace(m[0], v) : v;
  }

  function money(cents, format) {
    try {
      if (window.FoxTheme && FoxTheme.Currency && typeof FoxTheme.Currency.formatMoney === 'function') {
        return FoxTheme.Currency.formatMoney(Math.round(cents), format);
      }
    } catch (e) {}
    return fallbackMoney(cents, format);
  }

  function calc(unit, input) {
    var qty = parseInt(input.dataset.qty, 10) || 1;
    var type = input.dataset.type || 'none';
    var val = parseFloat(input.dataset.value) || 0;
    var base = unit * qty;
    var disc = 0;
    if (type === 'percent') disc = Math.floor((unit * val) / 100 + 1e-9) * qty; // като Shopify: надолу за всяка бройка
    else if (type === 'amount') disc = Math.round(val * 100);
    else if (type === 'free') disc = unit * val;
    disc = Math.max(0, Math.min(disc, base));
    return { base: base, disc: disc, total: base - disc, pct: base > 0 ? Math.round((disc * 100) / base) : 0 };
  }

  class BkQtyBreaks extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      this.form = document.getElementById(this.dataset.form);
      this.qtyInput = this.querySelector('.bkqb__qty');
      try {
        this.data = JSON.parse(this.querySelector('.bkqb__data').textContent);
      } catch (e) {
        this.data = { variants: {} };
      }

      // Полето +/− на темата (ако е включено): ползваме него, нашето скрито поле се изключва.
      var themeQty = document.getElementById('Quantity-' + this.dataset.section);
      if (themeQty && this.form && themeQty.form === this.form) {
        this.themeQty = themeQty;
        if (this.qtyInput) this.qtyInput.disabled = true;
        if (this.dataset.hideQty === 'true') {
          var wrap = themeQty.closest('.product-form__quantity');
          if (wrap) wrap.style.display = 'none';
        } else {
          themeQty.addEventListener('change', this.onThemeQty.bind(this));
        }
      }

      this.addEventListener('change', (e) => {
        if (e.target.classList && e.target.classList.contains('bkqb__input')) this.select(e.target);
      });

      if (this.form) {
        var idInput = this.form.querySelector('input[name="id"]');
        if (idInput) idInput.addEventListener('change', () => this.updatePrices(idInput.value));
      }
      this._onSubmit = this.onSubmit.bind(this);
      document.addEventListener('submit', this._onSubmit, true);

      var checked = this.querySelector('.bkqb__input:checked');
      if (checked) this.select(checked, true);
    }

    /* 25.10 struktura: кодът на избраното ниво се слага в количката още при избора (не чака „Добави“),
       защото приложения като OPTIS пращат формата сами и submit-ът не минава през нас.
       Махат се стари KUPI4-кодове на продукти, които не са в количката. Заявки само когато има какво да се прави. */
    syncCodes(sel, isInit) {
      var flag = false;
      try { flag = !!sessionStorage.getItem('bkqb_codes'); } catch (e) {}
      if (!sel && !flag) return;
      if (isInit && !flag && !sel) return;
      clearTimeout(this._syncT);
      this._syncT = setTimeout(() => {
        fetch(ROOT + 'cart.js', { headers: { Accept: 'application/json' } })
          .then((r) => r.json())
          .then((cart) => {
            var inCart = {};
            (cart.items || []).forEach((it) => { inCart[String(it.product_id)] = true; });
            var codes = (cart.discount_codes || []).map((d) => d.code).filter(Boolean);
            var keep = codes.filter((c) => {
              var m = /^KUPI4-(\d+)$/i.exec(c);
              if (!m) return true;
              if (sel && c.toLowerCase() === sel.toLowerCase()) return true;
              return !!inCart[m[1]];
            });
            if (sel && !keep.some((c) => c.toLowerCase() === sel.toLowerCase())) keep.push(sel);
            try { if (sel) sessionStorage.setItem('bkqb_codes', '1'); else if (!keep.some((c) => /^KUPI4-/i.test(c))) sessionStorage.removeItem('bkqb_codes'); } catch (e) {}
            if (keep.join(',') === codes.join(',')) return null;
            return fetch(ROOT + 'cart/update.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ discount: keep.join(',') }),
            });
          })
          .catch((err) => console.warn('[BK Купи повече] кодът не беше синхронизиран', err));
      }, 150);
    }

    disconnectedCallback() {
      if (this._onSubmit) document.removeEventListener('submit', this._onSubmit, true);
    }

    select(input, isInit) {
      this.querySelectorAll('.bkqb__opt').forEach((opt) => opt.classList.toggle('is-selected', opt.contains(input)));
      this.syncCodes(input && input.dataset.code ? input.dataset.code.trim() : '', !!isInit);
      var qty = parseInt(input.dataset.qty, 10) || 1;
      if (this.qtyInput) this.qtyInput.value = qty;
      if (this.themeQty) {
        this._syncing = true;
        this.themeQty.value = qty;
        this.themeQty.dispatchEvent(new Event('change', { bubbles: true }));
        this._syncing = false;
      }
    }

    onThemeQty() {
      if (this._syncing) return;
      var q = parseInt(this.themeQty.value, 10) || 1;
      var match = null;
      this.querySelectorAll('.bkqb__input').forEach((inp) => {
        if (!match && !inp.disabled && parseInt(inp.dataset.qty, 10) === q) match = inp;
      });
      this.querySelectorAll('.bkqb__input').forEach((inp) => (inp.checked = inp === match));
      this.querySelectorAll('.bkqb__opt').forEach((opt) => opt.classList.toggle('is-selected', !!match && opt.contains(match)));
    }

    updatePrices(variantId) {
      var unit = this.data.variants && this.data.variants[String(variantId)];
      if (unit === undefined || unit === null) return;
      var fmt = this.data.money;
      this.querySelectorAll('.bkqb__opt').forEach((opt) => {
        var input = opt.querySelector('.bkqb__input');
        if (!input) return;
        var r = calc(unit, input);
        var price = opt.querySelector('.bkqb__price');
        var compare = opt.querySelector('.bkqb__compare');
        var save = opt.querySelector('.bkqb__save');
        if (price) price.textContent = money(r.total, fmt);
        if (compare) {
          compare.textContent = money(r.base, fmt);
          compare.hidden = r.disc <= 0;
        }
        if (save) {
          var tpl = save.dataset.tpl || '';
          save.textContent = tpl.split('[сума]').join(money(r.disc, fmt)).split('[процент]').join(r.pct + '%');
          save.hidden = r.disc <= 0;
        }
      });
    }

    onSubmit(e) {
      if (!this.form || e.target !== this.form || this._passing) return;
      var input = this.querySelector('.bkqb__input:checked');
      var code = input && input.dataset.code ? input.dataset.code.trim() : '';
      if (input && this.qtyInput && !this.themeQty) this.qtyInput.value = parseInt(input.dataset.qty, 10) || 1;
      if (!code) return;

      e.preventDefault();
      e.stopImmediatePropagation();
      var submitter = e.submitter && e.submitter.form === this.form ? e.submitter : null;
      this.applyCode(code)
        .catch((err) => console.warn('[BK Купи повече] кодът не беше добавен', err))
        .then(() => {
          this._passing = true;
          try {
            if (submitter) this.form.requestSubmit(submitter);
            else this.form.requestSubmit();
          } finally {
            this._passing = false;
          }
        });
    }

    applyCode(code) {
      return fetch(ROOT + 'cart.js', { headers: { Accept: 'application/json' } })
        .then((r) => r.json())
        .then((cart) => {
          var codes = (cart.discount_codes || []).map((d) => d.code).filter(Boolean);
          var has = codes.some((c) => c.toLowerCase() === code.toLowerCase());
          if (has) return null;
          codes.push(code);
          return fetch(ROOT + 'cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ discount: codes.join(',') }),
          });
        });
    }
  }

  customElements.define('bk-qty-breaks', BkQtyBreaks);
})();
